module.exports = __webpack_public_path__ + "static/media/home-comp-logos-serious-cigars.ba29b007.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-comp-logos-serious-cigars.png
// module id = 273
// module chunks = 0